import { defineComponent as d, computed as a, openBlock as c, createElementBlock as s, createElementVNode as t, toDisplayString as f, createCommentVNode as h, normalizeStyle as n, createStaticVNode as p } from "vue";
const v = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "ae2b7a9c-b2c9-43fd-ba8f-3f4750844909" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#ae2b7a9c-b2c9-43fd-ba8f-3f4750844909)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#338af3" d="m0 256 256-52.3L512 256v256H0z"></path><path fill="#eee" d="M0 0h512v256H0z"></path><path fill="#6da544" d="M357.6 176.6 256 278.3 154.4 176.6a121.7 121.7 0 0 0-20.8 68.3v33.4c0 53.6 34.6 99.2 82.7 115.8a37 37 0 0 0 4 40l36.4-29.2 36.4 29.2a37 37 0 0 0 3.9-40.5 122.6 122.6 0 0 0 81.4-115.3v-33.4c0-25.3-7.6-48.7-20.8-68.3z"></path><path fill="#ffda44" d="M256 367.3c-49.1 0-89-40-89-89v-33.4a89.1 89.1 0 0 1 178 0v33.4c0 49-39.9 89-89 89z"></path><path fill="#338af3" d="M311.7 278.3v-33.4a55.7 55.7 0 0 0-111.4 0v33.4l55.7 11z"></path><path fill="#6da544" d="M200.3 278.3a55.7 55.7 0 0 0 111.4 0z"></path><path fill="#ffda44" d="M322.8 155.8A33.4 33.4 0 0 0 267 131v-19.6h11.2V89H267V78h-22v11h-11.2v22.3H245v19.6a33.4 33.4 0 0 0-44.5 49.8v19.6h111.3v-19.6c6.8-6.1 11-15 11-24.9z"></path>', 7), g = { fill: "none" }, z = ["r"], y = /* @__PURE__ */ d({
  __name: "sm",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = a(() => 512 + 2 * e.strokeWidth), o = a(() => -e.strokeWidth), r = a(() => 256 + e.strokeWidth / 2);
    return (x, w) => (c(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${o.value} ${o.value} ${l.value} ${l.value}`
    }, [
      _,
      t("g", m, [
        e.flagName ? (c(), s("title", k, f(e.flagName), 1)) : h("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, v));
  }
});
export {
  y as default
};
//# sourceMappingURL=sm-56c37e70.js.map
